import { Component, Prop, Vue } from 'vue-property-decorator';
import DrilldownList from './drilldown-list/drilldown-list';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import DrillDownChart from './drilldown-chart/drill-down-chart';
import PerformanceByGrade from './performance-by-grade/performance-by-grade';
import axios from 'axios';
import MonthYearPicker from '@/components/selector/month-year-picker/month-year-picker';
import moment from 'moment';
import { CompetencyModel } from '@/models/drill-down/competency';
import { DrillDownModel } from '@/models/drill-down/drill-down';
import { SubjectModel } from '@/models/drill-down/subject';
import { drillDownAPI } from '@/providers/apis/drill-down/drill-down';
import { groupsApi } from '@/providers/apis/groups/groups';
import UsageSummaryReport from '@/components/pull-up/usage-summary-drill-down/usage-summary-drill-down';
import PerformanceSummaryReport from '@/components/pull-up/performance-summary-drill-down/performance-summary-drill-down';
import { GroupsReport, ReportContext, ReportData, StruggleData } from '@/models/groups/report';
import { GroupsPerformance, PerformanceData } from '@/models/groups/performance';
import {
  GroupsReportRequest,
  GroupsCompetencyReportRequest,
  GroupsPerformanceRequest,
  GroupsPerformancePullRequest,
} from '@/models/groups/request-param';
import {
  ClassCompetency, ClassCompetencyContext,
  ClassCompetencyData, ReportPerformanceCompetencyModel,
  ReportPerformanceStatsModel,
} from '@/models/groups/class';
import DrilldownPerformance from './drilldown-performance/drilldown-performance';
import {
  GroupsTimespent,
  TimespentContext,
  TimespentData,
  TimespentCoOridnate,
  TimespentDrilldown,
  ClassTimespentData,
  ClassTimespent,
} from '@/models/groups/timespent';
import { appConfigService } from '@/providers/services/app/app-config';
import { sessionService } from '@/providers/services/auth/session';
import { getNetworkDefaultURL, isAPICatchError, sortByProperty } from '@/utils/utils';
import { consoleSerializer } from '@/providers/serializers/console/console';
import { SubjectsModel } from '@/models/groups/subjects';
import { profileAPI } from '@/providers/apis/profile/profile';
import { UsersData, UsersDrilldown, UsersModel } from '@/models/groups/users';
import { COMPETENCY_STUBS_LIST } from '@/utils/constants';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { GradeModel } from '@/models/taxonomy/grade';
import { classAPI } from '@/providers/apis/class/class';
import { LearningChallengesGrades } from '@/models/groups/learning-challenges';
declare global {
  interface Window {
    MYGInteraction?: (contextData: any) => void;
  }
}

@Component({
  name: 'country-drill-down',
  components: {
    'drill-down-chart': DrillDownChart,
    'drilldown-list': DrilldownList,
    'material-icon': GoogleMaterialIcon,
    'drilldown-performance': DrilldownPerformance,
    'texas-grade-list': PerformanceByGrade,
    'month-picker': MonthYearPicker,
    'usage-summary-drill-down': UsageSummaryReport,
    'performance-summary-drill-down': PerformanceSummaryReport,
  },
})

export default class DrillDown extends Vue {

  private get hasAnalyticAccess() {
    const access = this.$access;
    return access.hasPermission(access.menus.network, access.ACL.compDrillAnalytic) ||
      access.hasPermission(access.menus.network, access.ACL.compDashboard);
  }

  get isTenantAdmin() {
    const report = this.$access.menus;
    return this.$access.hasMenuAccess(report.reports);
  }

  private get isDemoTenant() {
    return appConfigService.isDemoTenant();
  }

  private get isSuperAdmin() {
    return this.$access.hasPermission(this.$access.menus.network, this.$access.ACL.all);
  }

  private get session() {
    return sessionService.getSession();
  }

  public get myGooruInsightsCdn() {
    return appConfigService.getMyGooruInsightsJsCdn();
  }

  private get isAtInitialLevel() {
    return this.breadcrumbItems.length <= 1;
  }

  private get isGuestUser() {
    return this.$access.isGuestUser('guest', 'guest');
  }

  private get activeTenantList() {
    const heirarchyList = this.$access.getSetHierarchyDetails();
    return heirarchyList;
  }

  private get hasReportPermission() {
    return this.$access.hasPageAccess(this.$access.menus.network, this.$access.ACL.showGPFCompReport);
  }

  private get tenantCounts() {
    let count = 0;
    this.activeTenantList.forEach((item: any) => {
      count += item.tenants.length;
    });
    return count;
  }

  private get isRestrictClass() {
    const tenantSettings = this.tenantSettings;
    return tenantSettings
      && tenantSettings.enable_learners_data_visibilty_pref
      && tenantSettings.enable_learners_data_visibilty_pref === 'on'
      && this.groupType === 'school';
  }

  public get superUserList() {
    return appConfigService.getTenantIds() || [];
  }

  private get isPLDemoTenant() {
    return appConfigService.isPLDemoTenant();
  }

  private get isShowTenantName() {
    return this.selectedTenant && (!this.isDemoTenant || !this.isSuperAdmin);
  }

  public isShowSummaryCard: boolean = false;

  public isShowPerformanceCard: boolean = false;

  public groupName!: string;

  private excludeInferred: boolean = false;

  // -------------------------------------------------------------
  // Properties

  private competencyData?: ReportData | any = [];

  private studentList: any = [];

  private countryId?: string;

  private countryData?: any;

  private paramsIds: any = {};

  private breadcrumbItems: Array<{ id?: number | string, name?: string, type?: string }> | any = [];

  private isLoaded: boolean = false;

  private isLoading: boolean = false;

  private isLoadingStubData: boolean = false;

  private seletedLevel?: DrillDownModel;

  private selectedDate: string = '';

  private subjectsList?: SubjectModel[] = [];

  private activeMonth: string = moment().format('MM');

  private activeYear: string = moment().format('YYYY');

  private demoDefaultMonth: string = '02';

  private demoDefaultYear: string = '2020';

  private hideProperty: boolean = false;

  private cardDetails: any = {};

  private hierarchyId: number = 0;

  private competencyReport!: GroupsReport;

  private performanceData: PerformanceData | any = [];

  private classCompetencyData?: ClassCompetencyData | any = [];

  private classTimespentData?: ClassTimespentData | any = [];

  private timespentData?: TimespentData | any = [];

  private frequency: string = 'daily';

  private isNotAccessible: boolean = false;

  private groupId?: number | string;

  private groupType: string = 'country';

  private classId!: string;

  private parentGroupName!: string;

  private learningReportData: any = [];

  private groupStubData?: any = [];

  private activeTenant: any = null;

  private subjectList: any = [];

  private breadcrumb: any = [];

  private urldata: any = {};

  private tenantSettings: any = null;

  private usersDrillDownData: UsersData = {} as UsersData;

  private activePullUp: string = 'performance';

  private activeSubject: any = null;

  private strugglingCompetencies: StruggleData[] = [];

  private selectedTenant: any = null;

  private allSubjectList: any = [];

  private isShowUsageSummary: boolean = false;

  private isShowPerformanceSummary: boolean = false;

  private classReportContext: ClassCompetencyContext = {} as ClassCompetencyContext;

  private competencyPerformance: ReportPerformanceStatsModel = {} as ReportPerformanceStatsModel;

  public updateBreadcrumb(group: any) {
    const activeItemIndex = this.breadcrumbItems.findIndex(
      (bItem: any) => bItem.id === group.id && bItem.type === group.type);
    if (activeItemIndex === 0) {
      this.breadcrumbItems.length = 1;
    } else if (activeItemIndex > 0) {
      this.breadcrumbItems.forEach((Item: any, index: any) => {
        if (index <= activeItemIndex) {
          this.breadcrumbItems.push(Item);
        }
      });
      this.breadcrumbItems.length = activeItemIndex + 1;
    } else {
      this.breadcrumbItems.push({
        id: group.id,
        name: group.name,
        type: group.type,
      });
    }
  }

  public getMyGooruLoginContext() {
    const contextData = {
      version: '1.0.0',
      clientId: '18c78d4b-3d59-4f92-aa2a-78d9a683f8db',
      clientKey: 'SuRb8qxEcNdZDdSoNBdVJhJ1NSo=',
      appId: '1cdc6bf0-b887-11eb-8529-0242ac130003',
      context: {
        type: 'login',
        action: 'login',
        user: {
          id: '14',
          username: 'tonystark@gooru.org',
          role: 'student',
          metadata: {
            firstName: 'Tony',
            lastName: 'Stark',
          },
        },
        data: null,
        content: [],
      },
    };
    return contextData;
  }

  public mounted() {
    if (this.isDemoTenant) {
      if (!document.getElementById('myg')) {
        const el = document.createElement('my-gooru');
        el.id = 'myg';
        document.body.appendChild(el);
      }
      if (!document.getElementById('mygooru-script')) {
        const script = document.createElement('script');
        script.id = 'mygooru-script';
        script.src = this.myGooruInsightsCdn;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
          const myg = (window as any).MYGInteraction;
          if (typeof myg === 'function') {
            myg(this.getMyGooruLoginContext(), (fallbackData: any) => {
              // explicitly ignore
              myg(this.getMyGooruContext(), (data: any) => {
                // explicitly ignore
              });
            });
          }
        };
      } else {
        const myg = (window as any).MYGInteraction;
        if (typeof myg === 'function') {
          myg(this.getMyGooruLoginContext(), (fallbackData: any) => {
            // explicitly ignore
            myg(this.getMyGooruContext(), (data: any) => {
              // explicitly ignore
            });
          });
        }
      }
    }
  }

  public beforeDestroy() {
    const el = document.getElementById('myg');
    if (el) {
      document.body.removeChild(el);
    }
    const script = document.getElementById('mygooru-script');
    if (script) {
      document.body.removeChild(script);
    }
  }

  // --------------------------------------------------------------
  // Hooks

  private async created() {
    await this.fetchTenantSetting();
    const existingLevel = this.$access.updateClassDrilldown();
    const paramItems = {
      params: this.$route.params,
      query: this.$route.query,
    };
    this.countryId = this.$route.params.id;
    if (this.isDemoTenant || this.isGuestUser) {
      this.activeMonth = this.demoDefaultMonth;
      this.activeYear = this.demoDefaultYear;
    }
    if (this.isPLDemoTenant) {
      this.activeMonth = this.demoDefaultMonth ;
      this.activeYear = '2023';
    }

    const queryParams: { hierarchyId?: string, groupId?: string, selectedLevel?: any } = this.$route.query;
    if (this.$route.query) {
      this.hierarchyId = parseInt(queryParams.hierarchyId as string, 10);
      this.groupId = queryParams.groupId;
    }
    this.groupName = this.$route.params.name;
    this.groupType = this.$route.params.groupType;
    this.breadcrumbItems.push({
      id: this.groupId,
      name: this.groupName,
      type: this.groupType,
    });
    this.parentGroupName = this.groupName;
    this.activeTenant = this.activeTenantList && this.activeTenantList.find(
      (item: any) => item.tenants.find((tenantItem: any) => tenantItem.id === this.getActiveHierarchyTenants()));
    this.selectedTenant = this.activeTenant.tenants.find(
      (tenantItem: any) => tenantItem.id === this.getActiveHierarchyTenants());
    if (existingLevel) {
      this.groupId = existingLevel.groupId;
      this.breadcrumbItems = existingLevel.breadCrumb;
      this.activeYear = existingLevel.year;
      this.activeMonth = existingLevel.month;
      const selectedLevel = this.breadcrumbItems[this.breadcrumbItems.length - 1];
      this.groupName = selectedLevel.name;
      this.groupType = selectedLevel.type;
      this.$access.deleteClassDrillDown();
    }
    this.loadData();
  }

  // ---------------------------------------------------------------
  // Actions

  private onSelectLevel(selectedLevel: any, subject: any = null, pullUp: any = '') {
    if (!selectedLevel) {
      this.activeSubject = subject;
      this.activePullUp = pullUp;
      if (this.groupType !== 'class') {
        this.fetchKPISubjectList();
      }
      this.loadData();
      return;
    }
    this.groupId = selectedLevel.id;
    this.groupName = selectedLevel.name;
    this.groupType = selectedLevel.type;
    this.activeSubject = subject;
    this.activePullUp = pullUp;
    // this.replaceRouterParams(selectedLevel);
    this.updateBreadcrumb(selectedLevel);
    this.loadData();
  }

  private onGoUpward(subject: any, data: any, active: any) {
    this.breadcrumbItems.pop();
    if (this.breadcrumbItems[this.breadcrumbItems.length - 1]) {
      const upwardLevel = this.breadcrumbItems[this.breadcrumbItems.length - 1];
      this.onSelectLevel(upwardLevel, subject, data);
    }
  }

  private replaceRouterParams(selectedLevel: any) {
    const params = {
      groupType: selectedLevel.type,
      name: selectedLevel.name,
    };
    const query = {
      groupId: selectedLevel.id,
      hierarchyId: this.hierarchyId,
      selectedLevel: selectedLevel.type,
    };
    this.$router.replace(getNetworkDefaultURL(params, query, true));
  }


  private backButton() {
    localStorage.removeItem('breadcrumbItems');
    localStorage.removeItem('URLData');
    this.$router.push('/network');
  }

  private onBack() {
    this.breadcrumbItems.pop();
    const lastElement = this.breadcrumbItems[this.breadcrumbItems.length - 1];
    if (lastElement) {
      if (lastElement.type) {
        this.groupType = lastElement.type;
      }
      if (lastElement.id) {
        this.groupId = lastElement.id;
      }
      if (lastElement.name) {
        this.groupName = lastElement.name;
      }
    }
    this.loadData();
  }

  private onChageTimeline(date: any) {
    this.activeMonth = moment(date).format('MM');
    this.activeYear = moment(date).format('YYYY');
    this.loadData();
  }

  private onToggleChart(frequency: string = 'daily') {
    if (frequency !== this.frequency) {
      this.frequency = frequency === 'weekly' ? 'weekly' : 'daily';
      this.loadData();
    }
  }

  private onSelectTenant(level: any, tenants: any) {
    const groupsReportParam = {
      hierarchyId: level.id,
      tenants: level.tenants.map((tenant: any) => tenant.id).join(','),
      month: this.activeMonth as any,
      year: this.activeYear as any,
    };
    this.$access.deleteClassDrillDown();
    groupsApi.fetchGroupReport(groupsReportParam).then((groupsReport) => {
      if (isAPICatchError(groupsReport)) {
        this.$router.push('/error');
      } else {
        // When don't have access to multiple countries
        if (groupsReport.data.length <= 1) {
          const defaultLevelData = groupsReport.data[0];
          const params = {
            groupType: defaultLevelData.type,
            name: defaultLevelData.name,
          };
          const query = {
            groupId: defaultLevelData.id,
            hierarchyId: level.id,
            selectedLevel: defaultLevelData.type,
          };
          this.$access.setGroupHierarchyTenants(JSON.stringify(tenants));
          appConfigService.setUserGroupAccessLevel(level.levels);
          // this.activeTenant = tenants;
          this.$router.push(
            getNetworkDefaultURL(params, query, true),
          );
          location.reload();
        }
      }
    });

  }

  private onSelectStrunggleSubject(subject: any) {
    this.onSelectSubject(subject);
  }

  private onSelectSubject(subject: any = null) {
    this.activeSubject = subject;
    this.loadGroupData(true, this.activeSubject);
  }

  private onToggleInferred(isShowInferred: boolean) {
    this.toggleInferredCompetency(isShowInferred);
  }

  private onShowUsageSummary() {
    this.isShowUsageSummary = true;
  }

  private onShowPerformanceSummary() {
    this.isShowPerformanceSummary = true;
  }

  private onCloseSummaryPullup() {
    this.isShowUsageSummary = false;
  }

  private onClosePerformancePullup() {
    this.isShowPerformanceSummary = false;
  }

  // --------------------------------------------------------------
  // Methods

  private loadData() {
    this.$access.deleteClassDrillDown();
    if (this.groupType === 'class') {
      this.loadClassData(false, null);
      this.strugglingCompetencies = [];
    } else {
      if (this.activePullUp) {
        this.fetchKPISubjectList();
      }
      this.loadGroupData(true, this.activeSubject);
    }
  }

  private loadGroupData(data: any, subject: any) {
    this.isLoading = true;
    axios.all([this.loadGroupCompetencyReportData(data, subject),
    this.loadGroupPerformance(this.activePullUp === 'performance', subject),
    this.loadGroupTimespent(this.activePullUp === 'timespent', subject),
    this.loadStubData(),
    this.loadGroupUsersCount(),
    this.groupType === 'class' ? this.loadStrugglingCompetency(subject) : this.getLearningChallengeData(subject),
    this.loadCompetencyReportData(data, subject),
    ]).then(axios.spread(
      (
        competencyReport: any,
        groupsPerformance: any,
        groupsTimespent: GroupsTimespent,
        groupStubData: any,
        usersCounts: UsersModel,
        strugglingComp: { context: ReportContext, data: any[] },
        competencyPerformance: { context: ReportContext, data: ReportPerformanceStatsModel[] },
      ) => {
        this.competencyReport = competencyReport;
        this.competencyData = competencyReport.data[0];
        this.performanceData = groupsPerformance.data[0];
        this.timespentData = groupsTimespent.data[0];
        this.usersDrillDownData = usersCounts.data[0];
        this.groupStubData = groupStubData.data;
        this.strugglingCompetencies = strugglingComp.data;
        this.learningReportData = strugglingComp.data || [];
        if (this.hasReportPermission) {
          this.competencyPerformance = competencyPerformance.data[0];
        }
        this.loadSubjectDetails();
        this.isLoaded = true;
        this.isLoading = false;
        if (this.competencyData.type === 'school') {
          const drilldown = this.competencyData.drilldown;
          this.checkInstructionalCoach(drilldown);
        }
        if (appConfigService.getDemoGroupItems()) {
          this.demoDataMapping();
        }
        if (this.excludeInferred) {
          this.toggleInferredCompetency(this.excludeInferred);
        }
      }), (e) => {
        this.isNotAccessible = true;
        this.isLoaded = true;
        this.isLoading = false;
      });
  }

  private checkInstructionalCoach(drilldownList: any) {
    const classId = drilldownList.map((item: any) => item.id).filter((item: any) => item !== null);
    if (classId.length) {
      this.isLoading = true;
      const classparams = {
        classIds: classId,
      };
      classAPI.fetchInstructionalCoachClass(classparams).then((data) => {
        return data.accessibleClassIds;
      }).then((data: any) => {
        const instructionalClassIds = data;
        drilldownList.forEach((drilldown: any) => {
          if (instructionalClassIds.includes(drilldown.id)) {
            this.$set(drilldown, 'hasInstructionalClass', true);
          } else {
            this.$set(drilldown, 'hasInstructionalClass', false);
          }
        });
        this.isLoaded = true;
        this.isLoading = false;
      });
    }

  }

  private loadClassData(data: any, subject: any) {
    this.isLoading = true;
    axios.all([this.loadClassCompetencyReport(data, subject),
    this.loadClassTimespent(data, subject),
    this.loadStubData(),
    this.loadClassStruggleCompetency(this.groupId)]).then(axios.spread(
      (
        classComeptencyReport: any,
        classTimespent: any,
        groupStubData: any,
        classStruggleCompetency: any) => {
        this.classCompetencyData = classComeptencyReport.data[0];
        this.classTimespentData = classTimespent.data[0];
        this.groupStubData = groupStubData.data;
        this.isLoaded = true;
        this.isLoading = false;
        const params = {
          groupId: this.groupId,
          breadCrumb: this.breadcrumbItems,
          month: this.activeMonth,
          year: this.activeYear,
          subject: classComeptencyReport.context.subject,
          framework: classComeptencyReport.context.framework,
          categoryId: classComeptencyReport.context.categoryId,
        };
        this.strugglingCompetencies = classStruggleCompetency.data;
        if (this.excludeInferred) {
          this.toggleInferredCompetency(this.excludeInferred);
        }
        this.$access.updateClassDrilldown(params);
      }), () => {
        this.isNotAccessible = true;
        this.isLoaded = true;
        this.isLoading = false;
      });
  }

  private loadStubData() {
    return groupsApi.fetchGroupsStub(this.groupId).then((stubData) => {
      return stubData;
    }, () => {
      return { data: {} };
    });
  }

  private loadGroupCompetencyReportData(data: any, subject: any) {
    return groupsApi.fetchGroupsCompetencyReport(data === true && subject ?
      this.getCompetencyReportBackQueryParams(subject) : this.getCompetencyReportQueryParams());
  }

  private loadClassCompetencyReport(data: any, subject: any) {
    return groupsApi.fetchClassCompetencyReport(this.getClassPerformanceQueryParams());
  }

  private loadClassTimespent(data: any, subject: any) {
    return groupsApi.fetchClassTimespentReport(this.getClassPerformanceQueryParams());
  }

  private loadClassInfo(classId: any) {
    return drillDownAPI.fetchClassInfo(classId);
  }

  private loadGradesList(subject: any) {
    return taxonomyAPI.fetchTaxonomyGrades(subject);
  }

  private loadClassStruggleCompetency(classId: any) {
    return new Promise((resolve, reject) => {
      this.loadClassInfo(classId).then((classDetails) => {
        if (classDetails.preference && classDetails.preference.subject) {
          this.loadGradesList(classDetails.preference.subject).then((taxonomyGrades: GradeModel[]) => {
            const gradeLists = taxonomyGrades.sort((a: any, b: any) => a.sequence - b.sequence);

            let gradeIds: any = '';
            gradeLists.forEach((element: any) => {
              gradeIds += element.id + ',';
            });
            gradeIds = gradeIds.slice(0, -1);

            const params = {
              grades: gradeIds,
              class: classId,
              month: parseInt(this.activeMonth, 10),
              year: parseInt(this.activeYear, 10),
            };
            groupsApi.fetchClassStruggleCompetency(params).then((struggle: any) => {
              resolve(struggle);
            });
          });
        } else {
          resolve({ data: [] });
        }

      });
    });
  }

  private loadGroupPerformance(data: any, subject: any) {
    return groupsApi.fetchGroupsPerformance(subject ?
      this.getCompetencyReportBackQueryParams(subject) : this.getCompetencyReportQueryParams());
  }

  private loadGroupTimespent(data: any, subject: any) {
    return groupsApi.fetchGroupsTimespent(subject ?
      this.getCompetencyReportBackQueryParams(subject) : this.getCompetencyReportQueryParams());
  }

  private loadStrugglingCompetency(subject: any) {
    return groupsApi.fetchStugglingCompetency(subject ?
      this.getCompetencyReportBackQueryParams(subject) : this.getCompetencyReportQueryParams());
  }
  private getLearningChallengeData(subject: any) {
    return drillDownAPI.fetchLearningChallengeData(subject ?
      this.getCompetencyReportBackQueryParams(subject) : this.getCompetencyReportQueryParams());
  }

  private loadGroupUsersCount() {
    return groupsApi.fetchGroupUsers(this.getCompetencyReportQueryParams());
  }

  private getActiveHierarchyTenants() {
    const groupHierarchyTenants = localStorage.getItem('GROUP_HIERARCHY_TENANTS');
    const activeTenants = groupHierarchyTenants ? JSON.parse(groupHierarchyTenants) : [];
    const tenantsIds = this.activeTenant ? this.activeTenant.tenants.map(
      (tenant: any) => tenant.id).join(',') : activeTenants.id;
    return tenantsIds;
  }

  private getCompetencyReportQueryParams(): GroupsPerformanceRequest {
    return {
      hierarchyId: this.hierarchyId,
      groupId: this.groupId,
      groupType: this.groupType,
      frequency: this.frequency,
      tenants: this.getActiveHierarchyTenants() || undefined,
      duration: 'month',
      month: parseInt(this.activeMonth, 10),
      year: parseInt(this.activeYear, 10),
    };
  }
  private getCompetencyReportBackQueryParams(subject: any): GroupsPerformancePullRequest {
    return {
      hierarchyId: this.hierarchyId,
      groupId: this.groupId,
      groupType: this.groupType,
      frequency: this.frequency,
      tenants: this.getActiveHierarchyTenants() || undefined,
      duration: 'month',
      month: parseInt(this.activeMonth, 10),
      year: parseInt(this.activeYear, 10),
      subject: subject.code,
      framework: subject.framework,
    };
  }

  private getClassPerformanceQueryParams() {
    return {
      classId: this.groupId,
      month: this.activeMonth,
      year: this.activeYear,
      frequency: this.frequency,
      duration: 'month',
    };
  }

  private getSubjectListParams() {
    return {
      hierarchyId: this.hierarchyId,
      groupId: this.groupId,
      groupType: this.groupType,
      tenants: this.getActiveHierarchyTenants() || undefined,
      duration: 'month',
      month: parseInt(this.activeMonth, 10),
      year: parseInt(this.activeYear, 10),
      kpi: this.activePullUp || 'performance',
    };
  }

  private fetchKPISubjectList() {
    return groupsApi.fetchGroupSubjects(this.getSubjectListParams()).then((subjects) => {
      const subjectList: any = subjects.data;
      const filterList: any = [];
      if (this.tenantSettings && this.tenantSettings.tx_sub_prefs && subjectList.length) {
        const allCodes = Object.values(this.tenantSettings.tx_sub_prefs)
          .flatMap((itemSub: any) => itemSub.gut_subject_codes || []);
        subjectList.forEach((item: any) => {
          const isFound = allCodes.includes(item.code);
          if (isFound) {
            filterList.push(item);
          }
        });
      }
      this.subjectList = this.tenantSettings && this.tenantSettings.tx_sub_prefs ? filterList : subjects.data;
    });
  }

  private fetchTenantSetting() {
    profileAPI.getTenantSettings().then((tenant) => {
      this.tenantSettings = tenant.tenant_settings ? tenant.tenant_settings : null;
      const visibilitySetting = this.tenantSettings.ui_element_visibility_settings;
      this.isShowPerformanceCard = visibilitySetting.mc_enable_performance_summary_card;
      this.isShowSummaryCard = visibilitySetting.mc_enable_usage_summary_card;
    });
  }

  /**
   * @function demoDataMapping help to map the drilldown to stub data
   * DEMO PURPOSE ONLY
   */
  private demoDataMapping() {
    let competencyData: any = this.competencyData.drilldown || [];
    const timespentData = this.timespentData.drilldown || [];
    const performanceData = this.performanceData.drilldown || [];
    const usersDrillDownData = this.usersDrillDownData.drilldown || [];
    const groupType = this.groupType;
    const DEMO_HIERARCHY_LIST: any = appConfigService.getDemoGroupItems();
    const mappingData = DEMO_HIERARCHY_LIST[groupType] || [];
    const struggleCompetencies = this.strugglingCompetencies;
    this.strugglingCompetencies.unshift(COMPETENCY_STUBS_LIST);
    if (mappingData.length && competencyData) {
      sortByProperty(competencyData, 'masteredCompetencies', 'DESC');
      competencyData = competencyData.slice(0, mappingData.length);
      const drilldownItems: any = {
        timespentData: [],
        performanceData: [],
        usersDrillDownData: [],
      };
      const findItem = (item: any, competency: any) => item.id === competency.id;
      competencyData.forEach((competency: any, index: number) => {
        competency.name = mappingData[index];
        const timespentItem = timespentData.find((item: any) => findItem(item, competency));
        if (timespentItem) {
          timespentItem.name = mappingData[index];
          drilldownItems.timespentData.push(timespentItem);
        }
        const performanceItem = performanceData.find((item: any) => findItem(item, competency));
        if (performanceItem) {
          performanceItem.name = mappingData[index];
          drilldownItems.performanceData.push(performanceItem);
        }
        const userItem = usersDrillDownData.find((item: any) => findItem(item, competency));
        if (userItem) {
          userItem.name = mappingData[index];
          drilldownItems.usersDrillDownData.push(userItem);
        }
      });
      this.competencyData.drilldown = competencyData;
      this.timespentData.drilldown = drilldownItems.timespentData;
      this.performanceData.drilldown = drilldownItems.performanceData;
      this.usersDrillDownData.drilldown = drilldownItems.usersDrillDownData;
    }
  }

  private toggleInferredCompetency(excludeInferred: boolean) {
    this.excludeInferred = excludeInferred;
    const calculateCompetency = (competency: any) => {
      const inferredCount = parseInt(competency.diagnosticInferredCompetencies, 0) +
        parseInt(competency.inferredCompetencies, 0);
      competency.masteredCompetencies += excludeInferred ? (-1 * inferredCount) : inferredCount;
    };
    if (this.competencyData && this.groupType !== 'class') {
      const { overallStats, drilldown, coordinates } = this.competencyData;
      const totalCount = overallStats.totalDiagnosticInferredCompetencies +
        overallStats.totalInferredCompetencies;
      overallStats.overallMasteredCompetencies += excludeInferred ? (-1 * totalCount) : totalCount;
      drilldown.forEach(calculateCompetency);
      coordinates.forEach(calculateCompetency);
    }
    if (this.classCompetencyData && this.groupType === 'class') {
      const { overallStats, drilldown } = this.classCompetencyData;
      const totalCount = overallStats.totalDiagnosticInferredCompetencies +
        overallStats.totalInferredCompetencies;
      overallStats.overallMasteredCompetencies += excludeInferred ? (-1 * totalCount) : totalCount;
      drilldown.forEach(calculateCompetency);
    }

  }

  private loadSubjectDetails() {
    const learningReportData = this.learningReportData;
    const subjectsList = learningReportData.map((item: any) => item.subjects);
    const flatSubjects = subjectsList.flat(1);
    const subjectCodes = flatSubjects.map((item: any) => item.subjectCode);
    const fetchSubjectPromise = axios.all(subjectCodes.map(
      (subject: string) => {
        if (this.allSubjectList[subject]) {
          return this.allSubjectList[subject];
        } else {
          const taxonomy = taxonomyAPI.fetchSubjectDetails(subject);
          this.allSubjectList[subject] = taxonomy;
          return taxonomy;
        }
      },
    ));
    fetchSubjectPromise.then((subjectDetails) => {
      flatSubjects.forEach((item: any) => {
        const subjectData: any = subjectDetails.find(
          (subject: any) => subject.code === item.subjectCode);
        if (subjectData) {
          item.subject = subjectData.title;
        }
      });
    });
  }

  private loadCompetencyReportData(data: any, subject: any) {
    return this.hasReportPermission ? (groupsApi.fetchCompetencyReportData(data === true && subject ?
      this.getCompetencyReportBackQueryParams(subject) : this.getCompetencyReportQueryParams())) : {};
  }

  private getMyGooruContext() {
    const sessionStr = localStorage.getItem('MC_SESSION');
    let token: string | undefined;
    if (sessionStr) {
      try {
        const session = JSON.parse(sessionStr);
        token = session.access_token;
      } catch (err) {
        // explicitly ignore
      }
    }
    const contextData = {
      version: '1.0.0',
      context: {
        type: 'mygooru-insights',
        action: 'init',
        user: {
          id: '4423a2e9-271b-4b8f-90e5-81c879be2a60',
          token,
        },
        data: {
          cdnUrl: 'https://cdn.gooru.org/myg-learn-widget/la_chatbot.html',
        },
        content: null,
      },
    };
    return contextData;
  }
}
